import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getCredits = () =>
  fetch(
    `${API_BASE_URL}/credits`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  .then(res => res.json())


export const saveCredit = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/credits`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editCredit = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/credits/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const deleteCredit = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/credits/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  return await res.json()
}